module.exports = __webpack_public_path__ + "img/ISO27001.d13f41c0.jpg";